import { Link } from 'react-router-dom';
import FadeInWrapper from '../components/FadeInWrapper';
import { useLanguage } from "../contexts/LanguageContext";
import { getTranslation } from "../translations";
import './Careers.css';

const positions = [
  { id: 1, key: 'mechanicalDesign', slug: 'mechanical-design' },
  { id: 2, key: 'electronicsHardware', slug: 'electronics-hardware' },
  { id: 3, key: 'robotSoftware', slug: 'robot-software' },
  { id: 4, key: 'robotAIEngineer1', slug: 'robot-ai-engineer-1' },
  { id: 7, key: 'robotAIEngineer2', slug: 'robot-ai-engineer-2' },
  { id: 5, key: 'robotControl', slug: 'robot-control' },
  { id: 6, key: 'firmware', slug: 'firmware' },
];

const formatTitle = (title) => {
  if (!title) return title;
  const parts = title.split(/([①②])/g);
  return parts.map((part, index) => {
    if (part === '①' || part === '②') {
      return <span key={index} className="circled-number">{part}</span>;
    }
    return part;
  });
};

function Careers() {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  return (
    <div className="page careers-page">
      {/* Hero Section */}
      <section className="careers-hero">
        <video
          className="careers-hero-video"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="/videos/allex/desc2-1.mp4" type="video/mp4" />
        </video>

      </section>

      {/* Content Section */}
      <section className="careers-content">
        {/* Intro */}
        <FadeInWrapper>
          <div className="careers-intro">
            <h1 className="careers-title">
              {t("careers.title")}<br />
              <span className="careers-title-light">{t("careers.titleAcc")}</span>
            </h1>
            <div className="careers-description">
              <p>{t("careers.description1")}</p>
              <p>{t("careers.description2")}</p>
              <p>{t("careers.description3")}</p>
              <p style={{ whiteSpace: "pre-line" }}>{t("careers.description4")}</p>
            </div>
          </div>
        </FadeInWrapper>

        {/* Positions */}
        <FadeInWrapper delay={200}>
          <div className="careers-positions">
            {positions.map((position) => (
              <Link
                key={position.id}
                to={`/career/${position.slug}`}
                className="careers-position-item"
              >
                <h2 className="careers-position-title">{formatTitle(t(`careers.positions.${position.key}`))}</h2>
                <img src="/icons/chevron.svg" alt="" className="careers-position-chevron" />
              </Link>
            ))}
            <a href="mailto:recruite@wirobotics.com" className="careers-position-item contact">
              <h2 className="careers-position-title">
                {t("careers.contactTitle")}<br />
                {t("careers.contactSubtitle")}
              </h2>
            </a>
          </div>
        </FadeInWrapper>
      </section>
    </div>
  );
}

export default Careers;
